import React, {useEffect, useState} from 'react';
import {
    useStyles, 
    ProductsPurchasedContainer,
    ProductPurchasedCard,
    ProductPurchasedImage,
    ProductPurchasedInfo,
} from './style';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { CustomIcon } from '../CustomIcon';
import CurrencyFormat from '../../utils/currencyFormat';
import {v4 as uuid} from 'uuid'
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';
import {  RegularPrice } from '../../theme/theme'; 
import AddFrom from '../../components/AddFrom';
import {calculatePriceWithTax, findAmountProduct, returnProduct} from '../../utils/formatData'
import { getReferenceDisplayText } from '../../utils/referencePresentation';

export const TablePdfSummaryProducts = (props:any) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    const classes = useStyles();

    const [items, setItems] = useState<any>([])

    useEffect(() => {
        const productsRefs= props.props.purchase.products.filter((item: any) => item.references && item.references.length > 0)
        const productsData = props.props.purchase.products.filter((item: any) => !(item.references && item.references.length > 0))
        if (productsRefs.length > 0) {
            productsRefs.map((product: any) => {
                product.references.map((itemRef: any) => {
                    itemRef.data = product.productData.references.find( (field: any) => field.id === itemRef.id)
                    productsData.push({...product, references: [itemRef]})
                })    
            })
        }
        setItems(productsData)
     

    }, [props.props.purchase.products])

    const mappingImgRef = (img: string, imgProduct: string) => {
      return img !== "" ? img : imgProduct
  }

  const getImageSrc = (product: any, mappingImgRef: Function) => {
    if (product.references && product.references.length > 0 && !product.references[0].data.img.endsWith('/null')) {
      return mappingImgRef(product.references[0].data.img, product.productData.img[0]) || product.productData.img[0];
    } else {
      return product.productData.img[0];
    }
  }

    return (
        <div>
            <Table>
               <div>
                   <ProductsPurchasedContainer>
                      <div style={{marginBottom : '2%' }}>
                        <div className={classes.icon}>
                                <CustomIcon type='contact' color='#000' size='12px'/>
                        </div>
                            <p className={classes.titleDetail}>
                              {language[homeState.default_language]["productSummary"]}
                            </p>
                      </div>
                          { 
                            items.map((product:any, index: number) => {
                                const referenceText = getReferenceDisplayText(
                                    product,
                                    homeState.default_language
                                );
                                return (
                                  <React.Fragment key={uuid()}>
                                    <div className={classes.products}>
                                        <TableRow>
                                        <TableCell style={{borderBottom: 'none'}} >
                                            <ProductPurchasedCard key={uuid()}>
                                                <ProductPurchasedImage src={getImageSrc(product, mappingImgRef)} alt={getImageSrc(product, mappingImgRef)} />
                                                <ProductPurchasedInfo>
                                                    <div>
                                                    {product.productData.title}
                                                    </div>
                                                    {referenceText && 
                                                    <div>
                                                        <p className='purchase-detail-product-reference'>{referenceText}</p>
                                                    </div>
                                                      }

                                                  { findAmountProduct(product, 'discountRate') > 0 &&
                                                        <>
                                                            <RegularPrice>
                                                            <CurrencyFormat
                                                                amount={calculatePriceWithTax(product.references && product.references.length > 0 ? product.references[0].data : product.productData)}
                                                            />
                                                            </RegularPrice>
                                                        </>
                                                    }
                                                    { product.references && product.references.length > 0  ?
                                                    <div>
                                                        <CurrencyFormat amount={product.references[0].data.amount !== 0 ? product.references[0].data.amount : product.references[0].data.netAmount} />
                                                        {`  x ${product.references[0].quantity} unidad`}
                                                    </div>
                                                        :
                                                    <div>
                                                        <CurrencyFormat amount={product.productData.amount !== 0 ? product.productData.amount : product.productData.netAmount} />
                                                        {`  x ${product.quantity} unidad`}
                                                    </div>
                                                        }

                                              
                                                </ProductPurchasedInfo>
                                            </ProductPurchasedCard>
                                          </TableCell>
                                        </TableRow>
                                    </div>
                                    { ((index+1) !== items.length) && (index+1) % 4 === 0 && <>
                                      <div style={{ pageBreakBefore: 'always' }} />
                                      <div style={{ height: '60px' }} />
                                    </>}
                                  </React.Fragment>
                                )
                              })
                          }
                          
                    </ProductsPurchasedContainer>
                  </div>
              
            <TableRow>
              <TableCell style={{paddingTop: 'none', border: "none" }}>
                  <ProductsPurchasedContainer style={{marginBottom : '0px',marginTop : '0px', border: "none" }}>
                      <div style={{marginBottom : '0px',marginTop : '0px' }}>
                        <div className={classes.icon}>
                                <CustomIcon type='contact' color='#000' size='12px'/>
                        </div>
                            <p className={classes.titleDetail} style={{marginBottom : '0px',marginTop : '0px' }}>
                              {language[homeState.default_language]["contactEcommerce"]}
                            </p>
                        </div>
                        <div className={classes.contact} style={{marginBottom : '0px',marginTop : '0px' }}>
                          <p style={{marginBottom : '0px' }}>{props.props.contactEcommerce.phone}</p>
                          <p style={{marginBottom : '0px' }}>{props.props.contactEcommerce.email}</p>
                        </div>
                  </ProductsPurchasedContainer>
                </TableCell>
            </TableRow>
          </Table>
        </div>
    )
}
